"use client";

export default function LeagueFilterV20Dropdown({
  open,
  loading,
  filteredLeagues,
  viewMode,
  onViewModeChange,
  liActiveAll,
  tempSelectedIds,
  leaguesByCountry,
  allFilteredSelected,
  onClearAll,
  onToggleLeague,
  onSelectAll,
  onConfirm,
  listScrollbarClassName,
}) {
  if (!open) return null;

  return (
    <div className="absolute left-0 right-0 top-full z-[9999] mt-1 flex max-h-[min(60vh,420px)] flex-col overflow-hidden rounded-lg border border-solid border-[var(--theme-primary)] bg-[var(--theme-foreground)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.2)]">
      <div className="shrink-0 border-b border-[var(--theme-border)] border-solid px-3 py-2">
        <div className="flex items-center justify-between text-xs uppercase">
          <span className="font-medium text-[var(--theme-text-muted)]">
            Xem theo
          </span>
          <div className="flex gap-1">
            <button
              type="button"
              onClick={() => onViewModeChange("league")}
              className={`rounded px-3 py-1.5 text-xs font-medium ${
                viewMode === "league"
                  ? "border border-[var(--theme-primary)] bg-[var(--theme-foreground)] text-[var(--theme-primary)]"
                  : "border border-[var(--theme-border)] border-solid football-surface-muted text-[var(--theme-text-muted)]"
              }`}
            >
              Giải đấu
            </button>
            <button
              type="button"
              onClick={() => onViewModeChange("country")}
              className={`rounded px-3 py-1.5 text-xs font-medium ${
                viewMode === "country"
                  ? "border border-[var(--theme-primary)] bg-[var(--theme-foreground)] text-[var(--theme-primary)]"
                  : "border border-[var(--theme-border)] border-solid football-surface-muted text-[var(--theme-text-muted)]"
              }`}
            >
              Quốc gia
            </button>
          </div>
        </div>
      </div>

      <div className={`min-h-0 flex-1 overflow-y-auto py-1 ${listScrollbarClassName}`}>
        {loading ? (
          <div className="px-3 py-8 text-center text-sm text-[var(--theme-text-muted)]">
            Đang tải danh sách giải đấu...
          </div>
        ) : filteredLeagues.length === 0 ? (
          <div className="px-3 py-8 text-center text-sm text-[var(--theme-text-muted)]">
            Không tìm thấy giải đấu nào
          </div>
        ) : viewMode === "league" ? (
          <ul className="m-0 flex list-none flex-col flex-nowrap p-0 select-none">
            <li
              className={`cursor-pointer px-2 py-1.5 text-sm ${
                liActiveAll
                  ? "bg-[var(--theme-primary)] text-white"
                  : "text-[var(--theme-text)] hover:bg-[var(--theme-primary)] hover:text-white"
              }`}
              onClick={onClearAll}
            >
              Tất cả giải đấu
            </li>
            {filteredLeagues.map((league) => {
              const active = tempSelectedIds.includes(league.id);
              const displayName = league.nameVN || league.name || "";
              return (
                <li
                  key={league.id}
                  className={`flex cursor-pointer items-center gap-2 px-2 py-1.5 text-sm ${
                    active
                      ? "bg-[var(--theme-primary)] text-white"
                      : "text-[var(--theme-text)] hover:bg-[var(--theme-primary)] hover:text-white"
                  }`}
                  onClick={() => onToggleLeague(league.id)}
                >
                  <span
                    className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border text-[9px] font-bold ${
                      active
                        ? "border-[var(--theme-highlight)] bg-[var(--theme-highlight)] text-white"
                        : "border-[var(--theme-border)] border-solid bg-[var(--theme-foreground)] text-transparent"
                    }`}
                  >
                    {active ? "✓" : ""}
                  </span>
                  {league.logo ? (
                    <img
                      src={league.logo}
                      alt=""
                      className="h-5 w-5 shrink-0 object-contain"
                    />
                  ) : null}
                  <span className="min-w-0 truncate" title={displayName}>
                    {displayName}
                  </span>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="flex flex-col gap-3 px-1 py-1">
            {leaguesByCountry.map((group) => (
              <div key={group.country}>
                <div className="flex items-center gap-1.5 px-1 py-0.5 text-[11px] font-semibold uppercase text-[var(--theme-text-muted)]">
                  {group.countryLogo ? (
                    <img
                      src={group.countryLogo}
                      alt={group.country}
                      className="h-5 w-5 object-contain"
                    />
                  ) : null}
                  <span>{group.country}</span>
                </div>
                <ul className="m-0 mt-1 list-none p-0 select-none">
                  {group.items.map((league) => {
                    const active = tempSelectedIds.includes(league.id);
                    const displayName = league.nameVN || league.name || "";
                    return (
                      <li
                        key={league.id}
                        className={`flex cursor-pointer items-center gap-2 px-2 py-1.5 text-sm ${
                          active
                            ? "bg-[var(--theme-primary)] text-white"
                            : "text-[var(--theme-text)] hover:bg-[var(--theme-primary)] hover:text-white"
                        }`}
                        onClick={() => onToggleLeague(league.id)}
                      >
                        <span
                          className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border text-[9px] font-bold ${
                            active
                              ? "border-[var(--theme-highlight)] bg-[var(--theme-highlight)] text-white"
                              : "border-[var(--theme-border)] border-solid bg-[var(--theme-foreground)] text-transparent"
                          }`}
                        >
                          {active ? "✓" : ""}
                        </span>
                        {league.logo ? (
                          <img
                            src={league.logo}
                            alt=""
                            className="h-5 w-5 shrink-0 object-contain"
                          />
                        ) : null}
                        <span className="min-w-0 truncate" title={displayName}>
                          {displayName}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="flex shrink-0 flex-wrap items-center justify-between gap-2 border-t border-[var(--theme-border)] border-solid bg-[var(--theme-bg)] px-3 py-2">
        <div className="flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={onSelectAll}
            className="flex items-center gap-1.5 text-xs text-[var(--theme-text)]"
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border text-[10px] font-bold ${
                allFilteredSelected
                  ? "border-[var(--theme-highlight)] bg-[var(--theme-highlight)] text-white"
                  : "border-[var(--theme-border)] border-solid bg-[var(--theme-foreground)]"
              }`}
            >
              {allFilteredSelected ? "✓" : ""}
            </span>
            Chọn tất cả
          </button>
          <button
            type="button"
            onClick={onClearAll}
            className="flex items-center gap-1.5 text-xs text-[var(--theme-text)]"
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border text-[10px] font-bold ${
                tempSelectedIds.length === 0
                  ? "border-[var(--theme-highlight)] bg-[var(--theme-highlight)] text-white"
                  : "border-[var(--theme-border)] border-solid bg-[var(--theme-foreground)]"
              }`}
            >
              {tempSelectedIds.length === 0 ? "✓" : ""}
            </span>
            Bỏ chọn tất cả
          </button>
        </div>
        <button
          type="button"
          onClick={onConfirm}
          className="shrink-0 rounded-lg bg-[var(--theme-primary)] px-4 py-1.5 text-xs font-semibold text-white"
        >
          Xác nhận
        </button>
      </div>
    </div>
  );
}
